import {
	GET_PAYMENT_OPTIONS_REQUEST,
	GET_PAYMENT_OPTIONS_SUCCESS,
	GET_PAYMENT_OPTIONS_ERROR,
	VOUCHER_ADD_OR_SELECT_REQUEST,
	VOUCHER_ADD_OR_SELECT_SUCCESS,
	VOUCHER_ADD_OR_SELECT_ERROR,
	RESET_PAYMENT_OPTIONS,
	PAYMENT_OPTION_SUCCESS_AND_MODIFY_SELECTED_OPTION
} from 'actions/PaymentActions/PaymentActions';
import { IPaymentTokenAction } from 'actions/paymentTokenActions';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { get } from 'lodash';
import { PAYMENT_INSTRUMENT } from 'pages/PaymentsPage/PaymentOptions/constants';

const INITIAL_STATE = {
	asyncStatus: INIT
};

export default function paymentOptions(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case IPaymentTokenAction.GET_PAYMENT_TOKEN_REQUEST:
		case RESET_PAYMENT_OPTIONS:
			const token = state.token;
			return Object.assign({}, INITIAL_STATE, { token });
		case GET_PAYMENT_OPTIONS_REQUEST:
		case VOUCHER_ADD_OR_SELECT_REQUEST:
			return Object.assign({}, state, { asyncStatus: LOADING, error: null, status: null });
		case GET_PAYMENT_OPTIONS_SUCCESS:
		case VOUCHER_ADD_OR_SELECT_SUCCESS:
			return Object.assign({}, state, {
				asyncStatus: SUCCESS,
				...action.data,
				timeStamp: new Date().getTime(),
				error: null,
				status: null
			});
		case PAYMENT_OPTION_SUCCESS_AND_MODIFY_SELECTED_OPTION:
			// TODO: This logic needs tests. And move to typescript.
			const options = get(action, 'data.options', []);

			for (let i = 0, len = options.length; i < len; i++) {
				const option = options[i];
				// Ugly variable name to denote the payment option from the
				// API response based on option type.
				const paymentType = (option => {
					// instead of re-checking payment_instrument, ideally `generateOptionKey`
					// method should be used here to define paymentType. Because the same function is used
					// to generate keys for each payment option and we are comparing paymentType with
					// the same key(action.paymentOption) below
					switch (option.payment_instrument) {
						case PAYMENT_INSTRUMENT.SAVED_CARD:
							return get(option, 'card_information.card_id');
						case PAYMENT_INSTRUMENT.WALLET:
							return get(option, 'payment_instrument') + get(option, 'section') + get(option, 'app_code', '');
						default:
							return option.payment_instrument;
					}
				})(option);

				// Toggle the `selected` option of the option based on the
				// payment option that user selected, rather than the default
				// option sent by API. We need to do this because otherwise,
				// there'd be an instrument check request right before the
				// user-selected option shows up and ends up in a race
				// condition between pay and instrument check requests.
				if (option.selected === true) {
					if (paymentType !== action.paymentOption) {
						option.selected = false;
					}
				} else if (paymentType === action.paymentOption) {
					option.selected = true;
				}
			}
			const updatedData = Object.assign(action.data, { options });

			return Object.assign({}, state, {
				asyncStatus: SUCCESS,
				...updatedData,
				timeStamp: new Date().getTime(),
				error: null,
				status: null
			});
		case GET_PAYMENT_OPTIONS_ERROR:
		case VOUCHER_ADD_OR_SELECT_ERROR:
			return Object.assign({}, state, { asyncStatus: ERROR, error: action.error, status: action.status });
		default:
			return state;
	}
}
